import { h } from 'preact';
import { Text } from 'preact-i18n';

// Small red badge shown next to a participant who, per their last Rubic sync,
// is not a member of the convention's club. Renders nothing when the flag is off.
// Only relevant for trainings — competitions (stevner) welcome shooters from
// other clubs, so the warning is hidden when convention.isCompetition is set.
const NotMemberBadge = ({ participant, convention }) => {
    if (!participant || !participant.notClubMember) {
        return null;
    }
    if (convention?.isCompetition) {
        return null;
    }
    return (
        <span class='badge text-bg-danger ms-1' title='Ikke medlem i klubben'>
            <i class='fa-solid fa-triangle-exclamation me-1' />
            <Text id='convention.not-club-member'>Not a member</Text>
        </span>
    );
};

export default NotMemberBadge;
